"use strict";
/****************************************************
 * Audit Information Platform Component
 * 高级查询（展示全字段查询）
 * 2021-01
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
var react_1 = require("react");
var tinper_bee_1 = require("tinper-bee");
var utils_1 = require("../utils");
require("../style/Other.css");
var LEFT_Q = ['', '(', '((', '(((', '((((', '(((((', '(((((('];
var RIGHT_Q = ['', ')', '))', ')))', '))))', ')))))', '))))))'];
var ASSIGNS = [
    { value: '', label: '' },
    { value: '==', label: (0, utils_1.getTranslate)(null, '等于') },
    { value: '>', label: (0, utils_1.getTranslate)(null, '大于') },
    { value: '>=', label: (0, utils_1.getTranslate)(null, '大于等于') },
    { value: '<', label: (0, utils_1.getTranslate)(null, '小于') },
    { value: '<=', label: (0, utils_1.getTranslate)(null, '小于等于') },
    { value: '<>', label: (0, utils_1.getTranslate)(null, '不等于') },
    { value: '===', label: (0, utils_1.getTranslate)(null, '包含') },
    { value: '!==', label: (0, utils_1.getTranslate)(null, '不包含') },
    { value: 'in', label: (0, utils_1.getTranslate)(null, '属于') },
    { value: 'not in', label: (0, utils_1.getTranslate)(null, "不属于") }
];
var ANDORS = [
    { value: '&&', label: (0, utils_1.getTranslate)(null, '且') },
    { value: '||', label: (0, utils_1.getTranslate)(null, '或') },
];
var EMPTY_STUB_COND_ITEM = {
    andor: '',
    leftQ: '',
    field: '',
    assign: '',
    value: '',
    rightQ: '',
};
/**
 * 每行条件组件
 */
var ConditionItem = /** @class */ (function (_super) {
    __extends(ConditionItem, _super);
    function ConditionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFirst: (_this.props.idx || 0) === 0,
            andor: (_this.props.cond && _this.props.cond.andor) || '',
            leftQ: (_this.props.cond && _this.props.cond.leftQ) || '',
            field: (_this.props.cond && _this.props.cond.field) || '',
            assign: (_this.props.cond && _this.props.cond.assign) || '',
            value: (_this.props.cond && _this.props.cond.value) || '',
            rightQ: (_this.props.cond && _this.props.cond.rightQ) || '',
            selectOn: _this.props.selectOn || false
        };
        _this.leftChange = function (e) {
            var v = (e.target && e.target.value) || '';
            _this.setState({
                leftQ: v,
            }, function () {
                // 这行代码不能写 2022-06-09
                _this.props.cond.leftQ = v;
            });
        };
        _this.rightChange = function (e) {
            var v = (e.target && e.target.value) || '';
            _this.setState({
                rightQ: v,
            }, function () {
                // 这行代码不能写 2022-06-09
                _this.props.cond.rightQ = v;
            });
        };
        _this.fieldChange = function (e) {
            var v = (e.target && e.target.value) || '';
            _this.setState({
                field: v,
                assign: '',
                value: ''
            }, function () {
                // 这行代码不能写 2022-06-09
                _this.props.cond.field = v;
                _this.props.cond.assign = '';
                _this.props.cond.value = '';
            });
        };
        _this.assignChange = function (e) {
            var v = (e.target && e.target.value) || '';
            var originValue = _this.state.assign;
            var value = _this.state.value;
            if (originValue.indexOf("in") >= 0) {
                value = '';
            }
            _this.setState({
                assign: v,
                value: value
            }, function () {
                _this.props.cond.assign = v;
                _this.props.cond.value = value;
            });
        };
        _this.andorChange = function (e) {
            var v = (e.target && e.target.value) || '';
            _this.setState({
                andor: v,
            }, function () {
                _this.props.cond.andor = v;
            });
        };
        _this.valueChange = function (e) {
            var v = (e.currentTarget && e.currentTarget.value) || '';
            _this.setState({
                value: v,
            }, function () {
                _this.props.cond.value = v;
            });
        };
        _this.addCond = function () {
            _this.props.addCond && _this.props.addCond();
        };
        _this.delCond = function () {
            _this.props.delCond && _this.props.idx && _this.props.delCond(_this.props.idx);
        };
        _this.appendCond = function () {
            _this.props.addCond && _this.props.addCond(_this.props.idx);
        };
        /**
         * 渲染属于/不属于组件
         */
        _this.renderSelectValue = function () {
            return (_this.state.assign.indexOf("in") >= 0 ?
                React.createElement("input", { className: 'fieldfilteritem', style: { width: 80, }, readOnly: true, onClick: function () {
                        _this.props.selectValue && _this.props.selectValue({
                            field: _this.state.field,
                            index: _this.props.idx
                        });
                    }, value: _this.state.value }) :
                React.createElement("input", { className: 'fieldfilteritem', style: { width: 80, }, onChange: _this.valueChange, value: _this.state.value }));
        };
        return _this;
    }
    ConditionItem.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.state.isFirst && (this.props.cond && !this.props.cond.field)) {
            var firstColumns_1 = {};
            if ((this.props.columns || []).length > 0) {
                firstColumns_1 = this.props.columns[0];
            }
            this.setState({
                andor: '&&',
                field: firstColumns_1.key
            }, function () {
                // 这两行代码不能写 2022-06-09
                _this.props.cond.field = firstColumns_1.key;
                _this.props.cond.andor = '&&';
            });
        }
    };
    ConditionItem.prototype.render = function () {
        var _this = this;
        if (!this.state.selectOn) {
            ASSIGNS.splice(9, 2);
        }
        var columns = __spreadArray([{ key: '', title: '' }], this.props.columns || [], true);
        if (this.state.isFirst) {
            return (React.createElement("div", { className: 'fieldfiltercondrow-first' },
                React.createElement("div", { className: 'fieldfilterconditiondiv' }, "\u00A0"),
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("select", { title: 'leftChange', className: 'fieldfilteritem', onChange: this.leftChange, value: this.state.leftQ }, LEFT_Q.map(function (item) { return (React.createElement("option", { selected: item === _this.state.leftQ, value: item }, item)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 160 } },
                    React.createElement("select", { title: 'fieldChange', className: 'fieldfilteritem', style: { width: 150, }, onChange: this.fieldChange, value: this.state.field }, columns.map(function (item) { return (React.createElement("option", { selected: item.key === _this.state.field, value: item.key }, item.completeTitle || item.title)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 90 } },
                    React.createElement("select", { title: 'assignChange', className: 'fieldfilteritem', style: { width: 80, }, onChange: this.assignChange, value: this.state.assign }, ASSIGNS.filter(function (item) {
                        if (item.label.indexOf("属于") >= 0) {
                            if (_this.props.selectValue) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        return true;
                    }).map(function (item) { return (React.createElement("option", { selected: item.value === _this.state.assign, value: item.value }, item.label)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 85 } }, this.renderSelectValue()),
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("select", { title: 'rightChange', onChange: this.rightChange, value: this.state.rightQ, className: 'fieldfilteritem' }, RIGHT_Q.map(function (item) { return (React.createElement("option", { selected: item === _this.state.rightQ, value: item }, item)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("button", { className: 'fieldfiltercondbutton', onClick: this.addCond }, "+"))));
        }
        else {
            return (React.createElement("div", { className: 'fieldfiltercondrow' },
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("select", { title: 'andorChange', style: { width: 50, }, className: 'fieldfilteritem', onChange: this.andorChange, value: this.state.andor }, ANDORS.map(function (item) { return (React.createElement("option", { value: item.value }, item.label)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("select", { title: 'leftChange', onChange: this.leftChange, value: this.state.leftQ, className: 'fieldfilteritem' }, LEFT_Q.map(function (item) { return (React.createElement("option", { selected: item === _this.state.leftQ, value: item }, item)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 160 } },
                    React.createElement("select", { title: 'fieldChange', style: { width: 150, }, className: 'fieldfilteritem', onChange: this.fieldChange, value: this.state.field }, (this.props.columns || []).map(function (item) { return (React.createElement("option", { value: item.key }, item.title)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 90 } },
                    React.createElement("select", { title: 'assignChange', style: { width: 80, }, className: 'fieldfilteritem', onChange: this.assignChange, value: this.state.assign }, ASSIGNS.map(function (item) { return (React.createElement("option", { value: item.value }, item.label)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 85 } }, this.renderSelectValue()),
                React.createElement("div", { className: 'fieldfilterconditiondiv' },
                    React.createElement("select", { title: 'rightChange', onChange: this.rightChange, value: this.state.rightQ, className: 'fieldfilteritem' }, RIGHT_Q.map(function (item) { return (React.createElement("option", { selected: item === _this.state.rightQ, value: item }, item)); }))),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 70 } },
                    React.createElement("button", { className: 'fieldfiltercondbutton', onClick: this.appendCond }, "+"),
                    "\u00A0",
                    React.createElement("button", { className: 'fieldfiltercondbutton', onClick: this.delCond }, "-"))));
        }
    };
    return ConditionItem;
}(react_1.PureComponent));
var Condition = /** @class */ (function (_super) {
    __extends(Condition, _super);
    function Condition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            conds: _this.props.filterParam || [],
            condKey: 'condKey',
            expression: '',
        };
        _this.getAndOr = function (v) {
            if (v === '||')
                return (0, utils_1.getTranslate)(null, '或');
            return (0, utils_1.getTranslate)(null, '且');
        };
        _this.getAssign = function (v) {
            var result = v;
            ASSIGNS.forEach(function (item) {
                if (item.value === v)
                    result = item.label;
            });
            return result;
        };
        _this.getField = function (v) {
            var result = v;
            (_this.props.columns || []).forEach(function (item) {
                if (v === item.key) {
                    result = item.completeTitle || item.title;
                }
            });
            return result;
        };
        _this.buildExpr = function () {
            var exprs = [];
            _this.state.conds.forEach(function (item) {
                var expr = (item.andor ? _this.getAndOr(item.andor) : ' ') + ' ' + (item.leftQ ? item.leftQ : '') + (item.field ? _this.getField(item.field) : '') + ' ' + (item.assign ? _this.getAssign(item.assign) : '') + ' ' + (item.value ? item.value : '') + (item.rightQ ? item.rightQ : '');
                exprs.push(expr);
            });
            _this.setState({
                expression: exprs.join(' '),
            }, function () {
            });
        };
        /**
         * 增加条件
         * @function
         * @param {number} idx 从第几个条件增加(可选)，默认为加到最后
         */
        _this.addCond = function (idx) {
            var c = JSON.parse(JSON.stringify(_this.state.conds));
            if (idx) {
                c.splice(idx + 1, 0, utils_1.Utils.cloneObject(EMPTY_STUB_COND_ITEM));
            }
            else {
                c.push(utils_1.Utils.cloneObject(EMPTY_STUB_COND_ITEM));
            }
            _this.setState({
                conds: c,
                condKey: Math.random(),
            }, function () {
            });
        };
        /**
         * 删除条件
         * @function
         *
         * @param {number} idx 条件索引
         */
        _this.delCond = function (idx) {
            var c = JSON.parse(JSON.stringify(_this.state.conds));
            c.splice(idx, 1);
            _this.setState({
                conds: c,
                condKey: Math.random(),
            }, function () {
            });
        };
        /**
         * 校验条件
         * @function
         *
         * @returns {boolean} 条件校验结果
         */
        _this.checkConditions = function () {
            var conStrs = [];
            _this.state.conds.forEach(function (item, idx) {
                var andor = (item.andor ? item.andor : (idx === 0 ? '' : '((('));
                var leftQ = (item.leftQ ? item.leftQ : '');
                var field = (item.field ? '1' : '(');
                var assign = (item.assign ? (item.assign === '!==' ? '==' : (item.assign === '<>' ? '==' : item.assign)) : '');
                if (assign.indexOf("in") >= 0) {
                    assign = '==';
                }
                var value = (item.value ? '1' : '(');
                var rightQ = (item.rightQ ? item.rightQ : '');
                var conStr = andor + ' ' + leftQ + ' ' + field + ' ' + assign + ' ' + value + ' ' + rightQ;
                conStrs.push(conStr);
            });
            var expr = '(' + conStrs.join('') + ')';
            try {
                utils_1.Utils.evil(expr);
                return true;
            }
            catch (e) {
                return false;
            }
        };
        _this.getCondition_unsafe = function () {
            return JSON.parse(JSON.stringify(_this.state.conds));
        };
        /**
         * 获取过滤条件
         * @function
         * @returns {CondItem[]} 过滤条件
         */
        _this.getConditions = function () {
            if (_this.checkConditions()) {
                return JSON.parse(JSON.stringify(_this.state.conds));
            }
            else {
                alert((0, utils_1.getTranslate)(null, '请完成过滤表达式，当前表达式未通过验证'));
                return null;
            }
        };
        /**
         * 获取过滤表达式
         * @function
         * @returns {string} 可读的表达式
         */
        _this.getCondExpression = function () {
            return _this.state.expression;
        };
        return _this;
    }
    // static getDerivedStateFromProps(props) {
    //     return {
    //         conds: props.filterParam,
    //     }
    // }
    Condition.prototype.UNSAFE_componentWillReceiveProps = function (preProps) {
        this.setState({
            conds: preProps.filterParam || [EMPTY_STUB_COND_ITEM],
        });
    };
    Condition.prototype.componentDidMount = function () {
        var _this = this;
        this.buildExpr();
        setInterval(function () {
            _this.buildExpr();
        }, 1000);
    };
    Condition.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { key: this.state.condKey },
            React.createElement("div", { style: { clear: 'both', marginBottom: 5, height: 25, borderBottom: '1px solid #CCC' } },
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "逻辑")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "括号")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 160, textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "名称")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 90, textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "操作符")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 85, textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "值")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { textAlign: 'center' } }, (0, utils_1.getTranslate)(null, "括号")),
                React.createElement("div", { className: 'fieldfilterconditiondiv', style: { width: 70, textAlign: 'center' } }, "\u00A0")),
            this.state.conds.map(function (item, idx) { return (React.createElement(ConditionItem, { key: 'ci_' + idx, cond: item, columns: _this.props.columns, idx: idx, selectOn: _this.props.selectOn, selectValue: _this.props.selectValue, addCond: _this.addCond, delCond: _this.delCond })); }),
            React.createElement("div", { className: 'fieldfilterexpr' },
                React.createElement(tinper_bee_1.FormControl, { readOnly: true, className: 'fieldfilterexprinput', componentClass: "textarea", value: this.state.expression, autoSize: { minRows: 3, maxRows: 6 } }))));
    };
    return Condition;
}(react_1.PureComponent));
/**
 * 字段过滤对话框
 * 提供字段过滤操作，组件关系如下： FieldsFilter(modal:ReactNode) 1..1 Condition(ReactNode) 1..n ConditionItem(ReactNode) 1..1 CondItem(PlainObject)
 */
var FieldsFilter = /** @class */ (function (_super) {
    __extends(FieldsFilter, _super);
    function FieldsFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.conditionRef = React.createRef();
        _this.state = {
            show: _this.props.show || false,
            columns: _this.props.columns || [],
            filterParam: _this.props.filterParam || [utils_1.Utils.cloneObject(EMPTY_STUB_COND_ITEM)],
            condKey: 'condKey',
            selectOn: _this.props.selectOn || false,
            originFilterParam: []
        };
        /**
         * 打开字段过滤器
         * @function
         * @param {any[]} columns 字段信息
         * @param {CondItem[]} filters 已存在的过滤条件
         */
        _this.open = function (columns, filters) {
            _this.setState({
                columns: columns,
                filterParam: filters || [{}],
                show: true,
                condKey: 'condKey' + Math.random(),
                originFilterParam: origin
            }, function () {
            });
        };
        /**
         * 获取过滤条件
         * @function
         * @returns {CondItem[]} 过滤条件
         */
        _this.getConditions = function () {
            var conditions = _this.conditionRef.current.getCondition_unsafe();
            if (conditions === null) {
                return [];
            }
            return conditions;
        };
        /**
         * 关闭过滤器对话框
         * @function
         */
        _this.close = function () {
            var origin = _this.state.originFilterParam || [];
            _this.setState({
                show: false,
                filterParam: origin
            }, function () {
                if (_this.props.filterParam) {
                    origin.forEach(function (item, index) {
                        _this.props.filterParam[index] = item;
                    });
                }
                try {
                    _this.conditionRef.current.buildExpr();
                }
                catch (e) {
                    // doNothing
                }
                _this.props.close && _this.props.close();
            });
        };
        /**
         * 过滤触发事件调用
         * @function
         *
         */
        _this.doSearch = function () {
            var conds = _this.conditionRef.current.getConditions();
            if (conds === null) {
                return;
            }
            _this.props.doSearch && _this.props.doSearch(_this.conditionRef.current.getConditions());
        };
        /**
         * 获取表达式
         * @function
         *
         * @returns {string}
         */
        _this.getCondExpression = function () {
            return _this.conditionRef.current.getCondExpression();
        };
        /**
         * 清除事件调用
         * @function
         */
        _this.doClean = function () {
            _this.props.doClean && _this.props.doClean();
        };
        return _this;
    }
    FieldsFilter.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var origin = JSON.parse(JSON.stringify(nextProps.filterParam || [utils_1.Utils.cloneObject(EMPTY_STUB_COND_ITEM)]));
        this.setState({
            show: nextProps.show,
            columns: nextProps.columns,
            filterParam: nextProps.filterParam,
            originFilterParam: origin
        });
    };
    FieldsFilter.prototype.render = function () {
        return (React.createElement(tinper_bee_1.Modal, { draggable: true, key: this.state.condKey, show: this.state.show, backdropClosable: false, enforceFocus: false, onHide: this.close, width: '690px' },
            React.createElement(tinper_bee_1.Modal.Header, { closeButton: true, closeButtonProps: { fieldId: 'closeBtn' } },
                React.createElement(tinper_bee_1.Modal.Title, null, (0, utils_1.getTranslate)(null, this.props.title || '数据过滤'))),
            React.createElement(tinper_bee_1.Modal.Body, null,
                React.createElement(Condition, { key: this.state.condKey + '_cond', ref: this.conditionRef, columns: this.state.columns, selectOn: this.state.selectOn, selectValue: this.props.selectValue, filterParam: this.state.filterParam || [] })),
            React.createElement(tinper_bee_1.Modal.Footer, null,
                React.createElement(tinper_bee_1.Button, { onClick: this.doSearch, bordered: true }, (0, utils_1.getTranslate)(null, "查询")),
                "\u00A0\u00A0",
                React.createElement(tinper_bee_1.Button, { onClick: this.close, bordered: true }, (0, utils_1.getTranslate)(null, "关闭")),
                "\u00A0\u00A0",
                React.createElement(tinper_bee_1.Button, { onClick: this.doClean, bordered: true }, (0, utils_1.getTranslate)(null, "重置")))));
    };
    return FieldsFilter;
}(react_1.PureComponent));
exports.default = FieldsFilter;
